export default function updateThemeTag(colorcode: string) {
    document.getElementsByName('theme-color')?.[0].setAttribute('content', colorcode);
}
